import { apiError } from "../utils/formErrors";
import React from 'react';
import {Dialog} from '@mui/material';
import { Stack } from "@mui/material";
import GoogleMap from "./googleMap";
import { upsertGeofence } from "../services/geofence";

import { useNotify } from "./NotificationProvider";

function GeofenceDialog({open, onClose}) {
const notify = useNotify();

const onMapSubmit = async (fences) => {
    try {
        const res = await upsertGeofence({ geofenceObj: fences });
        if (res?.success === false) throw apiError(res, "Could not save geofence");
        notify.success("Geofence saved");
        onClose();
    } catch (e) {
        notify.error(e?.message || "Could not save geofence");
    }
};

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width:"36.625rem",
          borderRadius: "8px",
          boxShadow: "0 4px 12px -4px rgba(42,29,34,0.16)",
          padding: "2.5rem 1.5rem",
          display:"flex",
          flexDirection:"column",
          alignItems:"center",
        }
      }}
    >
        <Stack
            margin="auto"
            paddingInline={"1.5rem"}
            paddingBlock={"2.25rem"}
            boxShadow={"0px 4px 20px 0px #2A1D2226"}
            borderRadius={"8px"}
            width={"100%"}
        >
          <GoogleMap onSubmit={onMapSubmit} />
        </Stack>
    </Dialog>
  );
}

export default GeofenceDialog;

